import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

interface ApiRequestOptions {
  url: string;
  method: AxiosRequestConfig['method'];
  body?: any;
  multipart?: boolean; // default false
  headers?: Record<string, string>; // opsiyonel header'lar
}

export const apiRequest = async (options: ApiRequestOptions): Promise<AxiosResponse<any>> => {
  const url = `${API_BASE_URL}${options.url}`;
  const { multipart = false, headers = {} } = options;

  const defaultHeaders: Record<string, string> = {
    'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
    ...(multipart ? {} : { 'Content-Type': 'application/json' }),
  };

  const mergedHeaders = {
    ...defaultHeaders,
    ...headers,
  };

  const requestOptions: AxiosRequestConfig = {
    method: options.method,
    headers: mergedHeaders,
  };

  if (options.body) {
    requestOptions.data = multipart ? options.body : JSON.stringify(options.body);
  }

  try {
    const response = await axios(url, requestOptions);
    return response;
  } catch (error: any) {
    if (error.response?.status === 401) {
      console.error('Unauthenticated, redirecting...');
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    throw error;
  }
};
